import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Toast from "react-bootstrap/Toast";
import * as api from "../../../services/apiService";
import "./FormEdit.scss";

function FormEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const isEditMode = !!id;

  const [name, setName] = useState("");
  const [link, setLink] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");

  useEffect(() => {
    async function fetchForm() {
      if (!isEditMode) return;

      try {
        const response = await api.getForms(); 
        if (response.ok) {
          const data = await response.json();
          const currentForm = data.find(f => f.id === parseInt(id));
          
          if (currentForm) {
            setName(currentForm.name);
            setLink(currentForm.link);
          } else {
            showNotification("Formularul nu a fost găsit.", "error");
            setTimeout(() => navigate("/dashboard/forms"), 2000);
          }
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    }
    fetchForm();
  }, [id, isEditMode, navigate]);

  const showNotification = (msg, type = "success") => {
    setToastMessage(msg);
    setToastType(type);
    setShowToast(true);
  };

  const handleSave = async () => {
    if (!name || !link) {
        showNotification("Numele și Link-ul sunt obligatorii.", "error");
        return;
    }

    try {
        let response;

        if (isEditMode) {
            // === EDIT MODE ===
            const request = {
                id: parseInt(id),
                name: name,
                link: link
            };
            response = await api.updateForm(request);
        } else {
            // === CREATE MODE ===
            const request = {
                name: name,
                link: link
            };
            response = await api.addForm(request);
        }
        
        if (response.ok) {
            showNotification(isEditMode ? "Formular actualizat!" : "Formular creat cu succes!");
            setTimeout(() => {
                navigate("/dashboard/forms");
            }, 1500);
        } else {
            showNotification("Eroare la salvare.", "error");
        }
    } catch (error) {
        console.error("Save error:", error);
        showNotification("Eroare de rețea.", "error");
    }
  };

  return (
    <div className="form-edit-container">
      <h2 className="page-title">
        {isEditMode ? "Editează Formular" : "Adaugă Formular Nou"}
      </h2>

      <div className="form-group">
        <label>Nume Formular</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input-field"
          placeholder="Ex: Feedback Event"
        />
      </div>

      <div className="form-group">
        <label>Link Formular</label>
        <input
          type="text"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          className="input-field"
          placeholder="https://docs.google.com/..."
        />
      </div>

      <div className="button-group">
        <button onClick={handleSave} className="save-button">
            Salvează
        </button>

        <Link to="/dashboard/forms" style={{ flex: 1 }}>
            <button className="cancel-button">
                Anulează
            </button>
        </Link>
      </div>

      <div className="toast-container-fixed">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          className={`custom-toast ${toastType === "error" ? "bg-danger text-white" : ""}`}
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Notificare</strong>
          </Toast.Header>
          <Toast.Body className={toastType === "error" ? "text-white" : ""}>
            {toastMessage}
          </Toast.Body>
        </Toast>
      </div>
    </div>
  );
}

export default FormEdit;